import { render, staticRenderFns } from "./GalleryPhoto.vue?vue&type=template&id=5f41db22&"
import script from "./GalleryPhoto.vue?vue&type=script&lang=js&"
export * from "./GalleryPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports